import http from './_http'

/**
 * 经纬度逆解析
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const positionGeocoder = (params = {}) => {
    return http({
        url: '/position/geocoder',
        method: 'get',
        params: { limit: 1, page: 1, ...params },
        meta: {
            toast: true,
            login: true,
            loading: true
        },
    });
}

/**
 * 经纬度周边搜索
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const positionSearch = (params = {}) => {
    return http({
        url: '/position/search',
        method: 'get',
        params: { limit: 10, page: 1, ...params },
        meta: {
            toast: true,
            login: true,
            loading: true
        },
    });
}
